import APIKit from "../Allapis/Apikit/apikit";

export const OtpVerification = async (body) => {
  try {
    const url = `/users/validate`;
    const result = await APIKit.post(url, body);
    return result;
  } catch (e) {
    console.log(e);
    return e.response ? e.response : e;
  }
};

export const resetPassword = async (body) => {
  try {
    const url = `/users/forgot`;
    const result = await APIKit.post(url, body);
    return result;
  } catch (e) {
    return e.response ? e.response : e;
  }
};

export const updatePassword = async (body) => {
  try {
    const url = `/users/reset`;
    const result = await APIKit.put(url, body);
    return result;
  } catch (e) {
    return e.response ? e.response : e;
  }
};
